import React, { useState } from "react";
import { Send, CheckCircle2, Loader2 } from "lucide-react";
import { useAdmin } from "../../context/AdminContext";

export default function Homesubs7() {
  const { addSubmission } = useAdmin();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const cleanEmail = email.trim();
    if (!cleanEmail) return;

    setIsSubmitting(true);

    addSubmission({
      formType: "Newsletter",
      fullName: "Homepage Subscriber",
      email: cleanEmail,
      service: "Tech Growth Monthly Insights",
      notes: "Subscribed via home section newsletter form."
    });

    try {
      const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
      const mailEndpoint = isLocal ? "http://localhost:5000/api/send-mail" : "/api/send-mail.php";

      await fetch(mailEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "Newsletter Subscription",
          fullName: "Homepage Subscriber",
          email: cleanEmail,
          service: "Tech Growth Monthly Insights",
          notes: "Subscribed via home section newsletter form."
        })
      });
    } catch (err) {
      // Graceful fallback
    } finally {
      setIsSubmitting(false);
      setSubscribed(true);
      setEmail("");
    }
  };

  return (
    <div className="w-full h-full flex flex-col justify-center items-center px-4 sm:px-6 bg-slate-950 text-white font-body py-12">
      <div className="max-w-xl mx-auto text-center space-y-6 glass-panel p-8 md:p-12 rounded-3xl border border-slate-800">
        <span className="text-xs font-bold uppercase tracking-widest text-cyan-400 font-heading">Stay Connected</span>
        <h2 className="font-heading text-2xl sm:text-4xl font-extrabold text-white">
          Subscribe for <span className="text-gradient-cyan">Growth Insights</span>
        </h2>
        <p className="text-slate-400 text-xs sm:text-sm font-medium">
          Receive monthly tech updates, website conversion tips, and app architecture insights directly to your inbox.
        </p>

        {subscribed ? (
          <div className="flex items-center justify-center gap-2 text-emerald-400 text-sm font-bold font-heading">
            <CheckCircle2 size={18} />
            <span>Thank you for subscribing!</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex gap-2 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your work email..."
              required
              className="flex-1 bg-slate-900 border border-slate-800 text-white text-xs px-4 py-3 rounded-xl focus:border-cyan-500 outline-none"
            />
            <button 
              type="submit" 
              disabled={isSubmitting} 
              className="cyber-btn-primary text-xs py-3 px-5 flex items-center gap-2 disabled:opacity-60"
            >
              <span>{isSubmitting ? "Subscribing..." : "Subscribe"}</span>
              {isSubmitting ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
